<label class="d-block mb-2" *ngIf="label" [for]="uniqueId">{{ label }}</label>
<div class="image-selector">
  <div
    class="image-container"
    [ngStyle]="{
      width: options.thumbnailSize.width + 'px',
      height: options.thumbnailSize.height + 'px'
    }"
  >
    <img class="image" [src]="preview" *ngIf="preview; else placeholder" />
    <div class="image-overlay">
      <ng-container *ngIf="value">
        <ng-container *ngTemplateOutlet="placeholder"></ng-container>
        <button
          class="delete-image"
          mat-mini-fab
          color="primary"
          [title]="'components.image-selector.delete-image' | translate"
          (click)="delete()"
        >
          <mat-icon>delete</mat-icon>
        </button>
      </ng-container>
    </div>
    <input
      [id]="uniqueId"
      #inputFile
      title=""
      [accept]="accept"
      type="file"
      class="file-input"
      (change)="onFileChange($event)"
    />
  </div>
</div>
<mat-hint *ngIf="!formControl?.touched || !formControl?.errors" class="d-block">
  <span translate [translateParams]="{ size: maxFileSize | byteFormat }">
    components.image-selector.max-image-size
  </span>
  <br />
  <span translate>components.image-selector.only-image</span>
</mat-hint>
<mat-error
  class="d-block"
  *ngIf="
    formControl?.touched && formControl?.hasError('imageTooBig');
    else unsupportedFileType
  "
  translate
  [translateParams]="{ maxFileSize: maxFileSize | byteFormat }"
>
  forms.errors.max-file-size
</mat-error>
<ng-template #unsupportedFileType>
  <mat-error
    class="d-block"
    *ngIf="formControl?.hasError('acceptedFileTypes')"
    translate
    [translateParams]="{
      supportedTypes: formControl?.getError('acceptedFileTypes')?.types
    }"
  >
    forms.errors.unaccepted-file-type
  </mat-error>
</ng-template>

<ng-template #placeholder>
  <div class="image-placeholder">
    <mat-icon>image</mat-icon>
    <p translate>components.image-selector.drag-drop-placeholder</p>
  </div>
</ng-template>
